import RootLanding from '../../components/layouts/RootLanding';
import useSWR from 'swr';
import { getFetcherPublic } from '../../services/api';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LayoutInformasi from '../../components/fragments/landing/LayoutInformasi';

export default function InformasiPage() {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const filterCategory = queryParams.get('kategori');

    const [selectedContentType, setSelectedContentType] = useState();
    const [search, setSearch] = useState();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(9999);

    const contentType = ['Berita', 'Artikel', 'Galeri'];

    const { data: news, isLoadingNews } = useSWR(
        `/api/content/search-news?page=${page}&limit=${limit}&sortBy=createdAt${filterCategory ? `&categoryName=${filterCategory}` : ''}${search ? `&name=${search}` : ''}`,
        getFetcherPublic
    );

    const { data: article, isLoadingArticle } = useSWR(
        `/api/content/search-articles?page=${page}&limit=${limit}&sortBy=createdAt${filterCategory ? `&categoryName=${filterCategory}` : ''}${search ? `&name=${search}` : ''}`,
        getFetcherPublic
    );

    const { data: gallery, isLoadingGallery } = useSWR(
        `/api/content/search-gallery?page=${page}&limit=${limit}&sortBy=createdAt${filterCategory ? `&categoryName=${filterCategory}` : ''}${search ? `&name=${search}` : ''}`,
        getFetcherPublic
    );

    const isLoading = isLoadingNews || isLoadingArticle || isLoadingGallery;

    const mergedData = useMemo(() => {
        if (!news || !article || !gallery) return [];

        switch (selectedContentType) {
            case 'Berita':
                return news;
            case 'Artikel':
                return article;
            case 'Galeri':
                return gallery;
            default:
                const merged = {
                    data: [...news?.data, ...article?.data, ...gallery?.data],
                };

                return merged;
        }
    }, [news, article, gallery, selectedContentType]);

    const handleChangeContentType = (selected) => {
        setLimit(10);
        setSelectedContentType(selected);
    };

    const handleSearch = (keyword) => {
        setSearch(keyword);
    };

    const handleNextPage = () => {
        if (news.total > news.page * news.limit) setPage(page + 1);
    };

    const handlePrevPage = () => {
        if (news.page > 1) setPage(page - 1);
    };

    return (
        <RootLanding>
            <LayoutInformasi
                title={`Informasi ${filterCategory}`}
                infoData={mergedData}
                contentType={contentType}
                selectedContentType={selectedContentType}
                setContentType={(selected) => handleChangeContentType(selected)}
                keyword={search}
                setSearch={(keyword) => handleSearch(keyword)}
                searchLabel="Cari Informasi"
                handleNextPage={handleNextPage}
                handlePrevPage={handlePrevPage}
                isLoading={isLoading}
            />
        </RootLanding>
    );
}
